<template>
    <div>
        <div
            class="kgr-alert kgr-alert--info kgr-row"
            v-html="$t('member.login.info')"
        ></div>

        <kgr-form-row
            :label="$t('E-Mail')"
            :error="error"
            :required="true"
            field-name="username"
        >
            <input
                v-model.trim="login.username"
                type="email"
                class="kgr-input"
                @input="onUsernameInput"
            />
        </kgr-form-row>
    </div>
</template>

<script>
import Error from '../../js/model/Error';
import FormRow from '../common/form/FormRow';
import Login from '../../js/dto/Login';

export default {
    components: {
        'kgr-form-row': FormRow,
    },
    props: {
        login: {
            type: Login,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    data() {
        return {
            hasUsername: this.login && this.login.username && this.login.username.length > 0
        };
    },
    computed: {
    },
    methods: {
        onUsernameInput() {
            this.hasUsername = this.login && this.login.username && this.login.username.length > 0;
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
